import React from 'react';
import type { NextPage } from 'next';
import { useTranslation } from 'react-i18next';

const About: NextPage = () => {
  const { t } = useTranslation();

  const paragraphs = t('about:text', { returnObjects: true });

  return (
    <main className="container">
      <div className="sitebar-left">
        <div className="page-title">
          <h2>{t('navigation:about')}</h2>
        </div>
      </div>
      <div className="container-content about-us">
        <div className="row">
          <div className="content">
            <p>
              {paragraphs?.map((item) => (
                <React.Fragment key={item}>
                  {item}
                  <br />
                  <br />
                </React.Fragment>
              ))}
            </p>
          </div>
        </div>
      </div>
      <div className="sitebar-right"></div>
    </main>
  );
};

export default About;
